<template>
  <div>
    <video
      style="display: none"
      id="monitorCaptureVideo"
      ref="video"
      class="canvas"
      autoPlay
      playsinline
    ></video>
<!--    :width="videoWidth"-->
<!--    :height="videoHeight"-->
    <canvas
      id="canvas"
      style="display: none"
      ref="canvas"
      class="canvas"
    ></canvas>
  </div>
</template>

<script>
import { markRaw } from "vue";
import { Toast } from "vant";
import Janus from "@/assets/js/janus";
import { RefreshUserInfo } from "@/services/login";
import { SaveMonitorLog } from "@/services/monitor";
import { doSend } from "@/utils/websocket";
import {lockPatientMonitor, releasePatientMonitor, UploadImage} from "@/services";
import { destroyJanusSession } from "@/utils/janusSession";

export default {
  name: "monitor",
  data() {
    return {
      // 定期截图用
      videoWidth: 500,
      videoHeight: 400,
      // janus用
      janus: null,
      janus_server: process.env.VUE_APP_JANUS_SERVER,
      opaqueId: "videoroomtest-" + Janus.randomString(12),
      sfutest: null,
      userInfo: null,
      monitorState: "idle",
      monitorConnectingAt: 0,
      monitorAttemptId: 0,
      roomJoinTimer: null,
      monitorLeaving: false,
      monitorLeaveTimer: null,
      monitorLeavePromise: null,
      monitorLeaveResolve: null,
      monitorNavigateBackOnLeave: true,
      monitorRouteTimer: null,
      monitorSetupTimer: null,
      monitorSetupTimeoutMs: 30000,
      // room用
      myroom: null,
      hanguproom: null,
      publishers_num: 20,
      mypvtid: null,
      myid: null,
      // 所有远程已订阅的媒体流信息
      feeds: [],
      subscriberHandles: markRaw(new Map()),
      // 不包括自己，所有用户的stream信息
      feedStreams: [],
      houseOwner: null,
      // 医生log用
      patient_id: null,
      successTimer: null,
      // 患者用
      publishStatus: false,
      needPublish: false,
      // 通话用
      remoteVideo: null,
      localStream: null,
      // 统计监视人数用
      watching_list: [],
      // 拍照间隔
      holdingTime: 5000,
      // ai模式flag
      ai_mode:false,
      ai_watching_list :[],
      ai_stream:null,
      ai_camera_time:null,
      aiHoldingTimer:null,
      aiMediaRequestPending:false,
      aiMediaRequestId:0,
      aiAnalysisStarted:false,
      aiAnalysisPaused:false,
    };
  },
  components: {},
  created() {},
  mounted() {},
  beforeUnmount() {
    this.aiAnalysisStarted = false;
    this.stopAiCapture();
    this.resetMonitorSession();
    this.resolveMonitorLeave();
  },
  methods: {
    clearTimer(timerName) {
      if (this[timerName]) {
        clearTimeout(this[timerName]);
        this[timerName] = null;
      }
    },
    isExclusiveMediaRoute(path = this.$route.path) {
      return [
        "/beforeCall",
        "/beforeRoom",
        "/singleCall",
        "/roomConversation",
        "/monitorRoom",
        "/openCall",
        "/patientrecord",
        "/audioBridgeList",
      ].includes(path);
    },
    stopAiCapture() {
      this.aiMediaRequestId++;
      this.aiMediaRequestPending = false;
      this.clearTimer("aiHoldingTimer");
      if (this.ai_stream) {
        this.ai_stream.getTracks().forEach((track) => track.stop());
        this.ai_stream = null;
      }
      this.ai_camera_time = null;
      if (this.$refs.video) {
        this.$refs.video.srcObject = null;
        this.$refs.video.onloadedmetadata = null;
      }
    },
    pauseAiAnalysis() {
      if (this.aiAnalysisPaused) {
        return;
      }
      this.aiAnalysisPaused = true;
      this.stopAiCapture();
      const userInfo = JSON.parse(
        localStorage.getItem(process.env.VUE_APP_USER_KEY) || "null"
      );
      if (this.aiAnalysisStarted && userInfo?.login_account_id) {
        releasePatientMonitor({
          patient_id: userInfo.login_account_id,
        }).catch(() => {});
      }
    },
    resumeAiAnalysis(delay = 1000) {
      if (!this.aiAnalysisStarted || this.isExclusiveMediaRoute()) {
        return;
      }
      this.aiAnalysisPaused = false;
      if (!this.aiHoldingTimer && !this.aiMediaRequestPending && !this.ai_stream) {
        this.holdingMonitorWithTime(delay);
      }
    },
    ensureMonitorLeavePromise() {
      if (!this.monitorLeavePromise) {
        this.monitorLeavePromise = new Promise((resolve) => {
          this.monitorLeaveResolve = resolve;
        });
      }
      return this.monitorLeavePromise;
    },
    resolveMonitorLeave() {
      const resolve = this.monitorLeaveResolve;
      this.monitorLeavePromise = null;
      this.monitorLeaveResolve = null;
      if (resolve) {
        resolve();
      }
    },
    isCurrentMonitorAttempt(attemptId, session) {
      return (
        attemptId === this.monitorAttemptId &&
        (!session || session === this.janus)
      );
    },
    isAiMonitorMode(value) {
      return [true, 1, "true", "1"].includes(value);
    },
    isCurrentMonitorSubscriber(subscriberKey, handle, attemptId, session) {
      return (
        this.isCurrentMonitorAttempt(attemptId, session) &&
        !!handle &&
        this.subscriberHandles.get(subscriberKey) === handle
      );
    },
    clearRemoteMonitorMedia() {
      ["remoteMonitorVideo", "remoteMonitorAudio"].forEach((id) => {
        const element = document.getElementById(id);
        if (!element) {
          return;
        }
        try {
          element.pause?.();
        } catch (error) {
          console.error(error);
        }
        element.srcObject = null;
      });
    },
    removeMonitorSubscriber(publisherId, notifyServer = true) {
      const key = String(publisherId);
      if (!this.subscriberHandles.has(key)) {
        return;
      }
      const handle = this.subscriberHandles.get(key);
      this.subscriberHandles.delete(key);
      if (!handle || typeof handle.detach !== "function") {
        return;
      }
      try {
        handle.detach({ noRequest: !notifyServer });
      } catch (error) {
        Janus.error("Failed to detach monitor subscriber:", error);
      }
    },
    clearMonitorSubscribers() {
      Array.from(this.subscriberHandles.keys()).forEach((publisherId) => {
        this.removeMonitorSubscriber(publisherId, false);
      });
      this.subscriberHandles.clear();
    },
    markMonitorVideoReady(videoElement) {
      const finish = () => {
        this.clearTimer("successTimer");
        Toast.clear();
      };
      try {
        const playPromise = videoElement.play?.();
        if (playPromise?.then) {
          playPromise.then(finish).catch((error) => Janus.error(error));
          return;
        }
      } catch (error) {
        Janus.error(error);
        return;
      }
      finish();
    },
    resetMonitorSession() {
      const session = this.janus;
      const wasLeaving = this.monitorLeaving;
      this.monitorAttemptId++;
      this.clearTimer("roomJoinTimer");
      this.clearTimer("monitorLeaveTimer");
      this.clearTimer("monitorRouteTimer");
      this.clearTimer("monitorSetupTimer");
      this.janus = null;
      this.sfutest = null;
      this.monitorState = "idle";
      this.monitorConnectingAt = 0;
      this.monitorLeaving = false;
      this.myroom = null;
      this.mypvtid = null;
      this.myid = null;
      this.publishStatus = false;
      this.needPublish = false;
      this.houseOwner = null;
      this.feeds = [];
      this.feedStreams = [];
      this.watching_list = [];
      this.ai_watching_list = [];
      this.ai_mode = false;
      this.clearMonitorSubscribers();
      if (this.localStream) {
        Janus.stopAllTracks(this.localStream);
        this.localStream = null;
      }
      this.clearRemoteMonitorMedia();
      this.$emit("monitor", { toPage: "app", method: "setMyRoom", myroom: "" });
      destroyJanusSession(session);
      if (wasLeaving) {
        this.resolveMonitorLeave();
      }
    },
    startMonitorSetupTimer(attemptId) {
      this.clearTimer("monitorSetupTimer");
      this.monitorSetupTimer = setTimeout(() => {
        this.monitorSetupTimer = null;
        if (
          this.isCurrentMonitorAttempt(attemptId) &&
          !this.monitorLeaving &&
          this.monitorState === "connecting"
        ) {
          this.resetMonitorSession();
          this.resumeAiAnalysis();
        }
      }, this.monitorSetupTimeoutMs);
    },
    isReusableMonitorSession(roomId) {
      if (this.monitorLeaving || this.myroom !== roomId) {
        return false;
      }
      if (this.monitorState === "connecting") {
        return Date.now() - this.monitorConnectingAt < 15000;
      }
      return (
        this.monitorState === "joined" &&
        this.janus?.isConnected?.() === true &&
        !!this.sfutest
      );
    },
    startOrReuseMonitorSession(roomId, needPublish, aiMode = false) {
      if (this.monitorLeaving) {
        return false;
      }
      if (this.isReusableMonitorSession(roomId)) {
        this.ai_mode = this.ai_mode || aiMode;
        this.needPublish = this.needPublish || needPublish;
        if (needPublish && this.monitorState === "joined") {
          this.publishMyFeed();
        }
        return true;
      }

      this.resetMonitorSession();
      this.myroom = roomId;
      this.needPublish = needPublish;
      this.ai_mode = aiMode;
      this.monitorState = "connecting";
      this.monitorConnectingAt = Date.now();
      const attemptId = this.monitorAttemptId;
      this.startMonitorSetupTimer(attemptId);
      this.JanusInit(attemptId);
      return true;
    },
    handleMonitorSessionFailure(attemptId, session, error) {
      if (error) {
        console.error(error);
      }
      if (!this.isCurrentMonitorAttempt(attemptId, session)) {
        destroyJanusSession(session);
        return;
      }
      if (this.monitorLeaving) {
        this.finishMonitorLeave();
        return;
      }
      if (this.monitorState === "joined") {
        this.monitorLeaving = true;
        this.hanguproom = this.myroom;
        this.myroom = null;
        this.finishMonitorLeave();
        return;
      }
      this.resetMonitorSession();
      this.resumeAiAnalysis();
    },
    doMethods(params) {
      const method = params["method"];
      const monitorStartMethods = [
        "startMonitor",
        "joinMonitor",
        "openPatientMonitor",
        "startBackgroundMonitor",
      ];
      if (this.monitorLeaving && monitorStartMethods.includes(method)) {
        return false;
      }
      // dz认证相关
      if (method !== "quitMonitor") {
        this.$emit("monitor", {
          toPage: "dzAndroid",
          method: "temporaryStopDz",
        });
      } else {
        this.$emit("monitor", { toPage: "dzAndroid", method: "recoveryDz" });
      }
      let userInfo = JSON.parse(localStorage.getItem(process.env.VUE_APP_USER_KEY));
      this.userInfo = userInfo;
      if (monitorStartMethods.includes(method)) {
        this.pauseAiAnalysis();
      }
      if (method == "startMonitor") {
        // 患者主动进入监护模式
        this.startOrReuseMonitorSession(this.createRoomId(userInfo.id), false);
      } else if (method == "joinMonitor") {
        // 医生进入监护模式详情页面
        this.patient_id = params["patient_id"];
        const aiMode = this.isAiMonitorMode(params["ai_mode"]);
        this.startOrReuseMonitorSession(
          this.createRoomId(params["id"]),
          false,
          aiMode
        );
      } else if (method == "openPatientMonitor") {
        // 医生想要打开患者的后台监护模式
        if (this.janus || this.myroom) {
          this.resetMonitorSession();
        }
        Toast.loading({
          mask: true,
          message: "",
          duration: 0,
          forbidClick: true,
        });
        // 移动到onremotetrack的时候才关闭loading
        let msg = {
          send_type: "openPatientMonitor",
          ai_mode : params["ai_mode"],
          to_users: [params["patient_id"]],
        };
        doSend(JSON.stringify(msg));
        // 最好是等患者先进
        this.clearTimer("monitorRouteTimer");
        this.monitorRouteTimer = setTimeout(() => {
          this.monitorRouteTimer = null;
          if (
            this.monitorLeaving ||
            (this.isExclusiveMediaRoute() && this.$route.path !== "/monitorRoom")
          ) {
            this.clearTimer("successTimer");
            Toast.clear();
            this.resetMonitorSession();
            this.resumeAiAnalysis();
            return;
          }
          this.$router.push({
            path: "/monitorRoom",
            query: {
              type: "joinMonitor",
              id: params["id"],
              patient_id: params["patient_id"],
              ai_mode :params["ai_mode"],
            },
          });
        }, 2000);
        this.clearTimer("successTimer");
        this.successTimer = setTimeout(() => {
          this.successTimer = null;
          if (this.monitorLeaving) {
            return;
          }
          Toast.clear();
          Toast("監視モードをオンにできませんでした。");
          this.resetMonitorSession();
          this.resumeAiAnalysis();
          if (this.$route.path === "/monitorRoom") {
            this.$router.go(-1);
          }
        }, 30000);
      } else if (method == "startBackgroundMonitor") {
        // 患者后台进入监护模式
        const aiMode = this.isAiMonitorMode(params["ai_mode"]);
        this.startOrReuseMonitorSession(
          this.createRoomId(userInfo.id),
          true,
          aiMode
        );
      } else if (method == "quitMonitor") {
        // 退出监护模式
        return this.doHangup({ navigateBack: params["fromPage"] !== "app" });
      }else if(method == "startAiAnalysis"){
        this.holdingTime = params["time"];
        this.aiAnalysisStarted = true;
        this.resumeAiAnalysis(5000);
      }
    },
    createRoomId(value) {
      let num = parseInt(value);
      return 1000000000 + num;
    },
    async JanusInit(attemptId) {
      this.$emit("monitor", {
        toPage: "app",
        method: "setMyRoom",
        myroom: this.myroom,
      });
      try {
        let userRet = await RefreshUserInfo();
        if (!this.isCurrentMonitorAttempt(attemptId)) {
          return;
        }
        let userInfo = userRet.data.data.user;
        localStorage.setItem(process.env.VUE_APP_USER_KEY, JSON.stringify(userInfo));
        this.userInfo = userInfo;
      } catch (error) {
        this.handleMonitorSessionFailure(attemptId, null, error);
        return;
      }
      Janus.init({
        debug: "all",
        callback: () => {
          if (!this.isCurrentMonitorAttempt(attemptId)) {
            return;
          }
          if (!Janus.isWebrtcSupported()) {
            alert("No WebRTC support... ");
            this.handleMonitorSessionFailure(attemptId);
            return;
          }
          this.createJanusSession(attemptId);
        },
      });
    },
    getMonitorIceServers() {
      const host = window.location.host;
      if (host.indexOf("stg") !== -1) {
        return [
          {
            urls: "turn:52.194.48.148:3478",
            username: "test",
            credential: "12345678",
          },
        ];
      }
      if (host.indexOf("localhost") !== -1 || host.indexOf("tmp") !== -1) {
        return [
          {
            urls: "turn:43.154.16.102:3478",
            username: "lqf",
            credential: "123456",
          },
        ];
      }
      return [
        {
          urls: "turn:35.78.136.103:3478",
          username: "lqf",
          credential: "123456",
        },
      ];
    },
    createJanusSession(attemptId) {
      let session = null;
      session = new Janus({
        server: this.janus_server,
        iceServers: this.getMonitorIceServers(),
        success: () => {
          if (!this.isCurrentMonitorAttempt(attemptId, session)) {
            destroyJanusSession(session);
            return;
          }
          //创建session成功时
          //添加插件！
          this.attachVideoRoom(attemptId, session);
        },
        error: (error) => {
          this.handleMonitorSessionFailure(attemptId, session, error);
        },
        destroyed: () => {
          this.handleMonitorSessionFailure(attemptId, session);
        },
      });
      this.janus = markRaw(session);
    },
    attachVideoRoom(attemptId, session) {
      //在初期化成功之后，调用此函数
      let primaryHandle = null;
      session.attach({
        plugin: "janus.plugin.videoroom",
        opaqueId: this.opaqueId,
        success: (pluginHandle) => {
          if (!this.isCurrentMonitorAttempt(attemptId, session)) {
            pluginHandle.detach?.();
            return;
          }
          //插件初始化成功时!
          primaryHandle = pluginHandle;
          this.sfutest = markRaw(pluginHandle);
          this.createRoom(pluginHandle);
          this.clearTimer("roomJoinTimer");
          this.roomJoinTimer = setTimeout(() => {
            this.roomJoinTimer = null;
            if (
              this.isCurrentMonitorAttempt(attemptId, session) &&
              this.sfutest === pluginHandle
            ) {
              this.registerRoomUser(pluginHandle);
            }
          }, 1500);
        },
        error: (error) => {
          this.handleMonitorSessionFailure(
            attemptId,
            session,
            "Error attaching monitor plugin: " + error
          );
        },
        consentDialog: (on) => {
          //如果没有权限，这里需要让用户给权限？
        },
        iceState: (state) => {
          //iceState 主要用于标识 ICE 连接的状态，包括新建连接、连接中、连接成功等状态
          console.log("ICE state changed to " + state);
        },
        mediaState: (medium, on, mid) => {
          console.log("mediaState changed to " + on);
        },
        webrtcState: (on) => {
          if (!this.isCurrentMonitorAttempt(attemptId, session)) {
            return;
          }
          console.log("webrtcState changed to " + on);
          if (!on) {
            this.publishStatus = false;
            return;
          }
          primaryHandle?.send({
            message: { request: "configure", bitrate: 256000 },
          });
        },
        slowLink: (uplink, lost, mid) => {
          //网络不好的时候调用，这时候应该关闭自己的视频，但通过chrome测试好像没有触发！
          console.log("network slow!");
        },
        onmessage: (msg, jsep) => {
          if (!this.isCurrentMonitorAttempt(attemptId, session)) {
            return;
          }
          console.log("收到消息！！！！！！！！！！");
          console.log(msg);
          //当收到消息时调用
          //获取event的类型
          let event = msg["videoroom"];
          if (event) {
            if (event === "joined") {
              this.monitorState = "joined";
              this.monitorConnectingAt = 0;
              this.clearTimer("monitorSetupTimer");
              //当自己加入到房间时
              //myid: 不确定代表什么
              this.myid = msg["id"];
              //mypvtid：加入房间之后，应该是代表自己的id，后面会用于订阅别人
              this.mypvtid = msg["private_id"];
              if (msg["publishers"]) {
                this.newRemoteFeed(msg["publishers"], attemptId, session);
              }
              if (this.needPublish) {
                this.publishMyFeed();
              }
              if (this.userInfo.type === "4") {
                SaveMonitorLog({
                  patient_id: this.patient_id,
                  room_id: this.myroom,
                  type: "join",
                }).then((res) => {});
              }
            } else if (event === "destroyed") {
              Janus.warn("The room has been destroyed!");
              this.doHangup();
            } else if (event === "event") {
              console.log(msg);
              // 收到event：自己的stream，新的发布者（有人加入），有人离开，有人不发布了，error
              if (msg["streams"]) {
                //实际意义不大—？
                let streams = msg["streams"];
                for (let i in streams) {
                  let stream = streams[i];
                  stream["id"] = this.myid;
                }
              } else if (msg["publishers"]) {
                console.log("有发布者加入");
                if (msg["publishers"]) {
                  this.newRemoteFeed(msg["publishers"], attemptId, session);
                }
              } else if (msg["joining"]) {
                console.log("加入中！！！！！！！！！！！！！！");
                console.log(msg);
                if (this.userInfo.type == "5") {
                  if (!this.watching_list.includes(msg["joining"].id)) {
                    this.watching_list.push(msg["joining"].id);
                  }
                  if(
                    msg["joining"].display?.startsWith("ai") &&
                    !this.ai_watching_list.includes(msg["joining"].id)
                  ){
                    this.ai_watching_list.push(msg["joining"].id);
                  }
                  this.publishMyFeed();
                }
              } else if (msg["leaving"]) {
                // 页面刷新时，会先触发unpublished，然后触发 leaving
                //删除离开者
                console.log("有人离开");
                console.log(msg);
                let leaving = msg["leaving"];
                if (leaving !== "ok") {
                  this.removeMonitorSubscriber(leaving);
                }
                if (
                  this.userInfo.type === "4" &&
                  leaving == this.houseOwner &&
                  !this.monitorLeaving
                ) {
                  Toast("相手方は現在通話中。");
                  this.doHangup();
                  return;
                }
                if (this.userInfo.type == "5") {
                  let getLocation = this.watching_list.indexOf(leaving);
                  if (getLocation !== -1) {
                    this.watching_list.splice(getLocation, 1);
                  }
                  let getLocation2 = this.ai_watching_list.indexOf(leaving);
                  if (getLocation2 !== -1) {
                    this.ai_watching_list.splice(getLocation2, 1);
                  }
                  if(this.ai_watching_list.length == 0){
                    this.ai_mode = false;
                  }
                  if (this.userInfo.type == "5" && this.watching_list.length == 0) {
                    if (this.$route.path == "/monitorRoom") {
                      this.unpublishFeed();
                    } else {
                      this.doHangup();
                    }
                  }
                }
                if (leaving === "ok") {
                  this.finishMonitorLeave();
                  return;
                }
              } else if (msg["unpublished"]) {
                var unpublished = msg["unpublished"];
                if (unpublished === "ok") {
                  if (this.userInfo.type === "5") {
                    this.publishStatus = false;
                  }
                  return;
                }
                this.removeMonitorSubscriber(unpublished);
                if (unpublished == this.houseOwner) {
                  Toast("相手方は現在通話中。");
                  this.doHangup();
                }
              } else if (msg["error"]) {
                if (this.userInfo.type === "5") {
                  this.publishStatus = false;
                }
                if (msg["error_code"] === 426) {
                  // This is a "no such room" error: give a more meaningful description
                  console.log("error! room does not exist!");
                  this.doHangup();
                } else {
                  console.log(msg["error"]);
                }
              }
            }
          } else {
            console.error("event is null!");
          }
          //handleRemoteJsep
          if (jsep) {
            primaryHandle?.handleRemoteJsep({ jsep: jsep });
            //TODO: 这里需要判断本地音视频流是否未获取成功，比如被拒绝
          }
        },
        onlocaltrack: (track, on) => {
          if (!this.isCurrentMonitorAttempt(attemptId, session)) {
            if (on) {
              track.stop?.();
            }
            return;
          }
          console.log("onlocaltrack");
          // 记录一下发布的流 结束的时候关掉
          if (!on) {
            if (track.kind === "video") {
              this.localStream = null;
              this.publishStatus = false;
            }
            return;
          }
          if (track.kind === "video") {
            let stream = new MediaStream([track]);
            this.localStream = stream;
          }
        },
        onremotetrack: (track, mid, on) => {
          console.log("onremotetrack");
        },
        oncleanup: () => {},
        ondetached: () => {
          this.handleMonitorSessionFailure(
            attemptId,
            session,
            "Monitor plugin detached"
          );
        },
      });
    },
    publishMyFeed() {
      const handle = this.sfutest;
      if (
        this.publishStatus ||
        this.monitorState !== "joined" ||
        !handle ||
        this.janus?.isConnected?.() !== true
      ) {
        return;
      }
      this.publishStatus = true;
      //发布自己
      //tracks:设置音频，视频等,recv 为什么是false
      let tracks = [];
      tracks.push({ type: "audio", capture: true, recv: false });
      tracks.push({
        type: "video",
        capture: true,
        recv: false,
        simulcast: false,
      });
      tracks.push({ type: "data" });
      //每个参与房间的用户都会通过信令服务器相互交换等待发送和接收音视频媒体流的信息
      handle.createOffer({
        tracks: tracks,
        customizeSdp: (jsep) => {},
        success: (jsep) => {
          if (handle !== this.sfutest || this.monitorState !== "joined") {
            return;
          }
          console.log("create offer success!");
          // 第一次加载，不加载发布不出来
          // 设置vido和audio的false或者true并不起作用，不管发送什么都是一样效果
          let publish = { request: "configure" };
          handle.send({ message: publish, jsep: jsep });
        },
        error: (error) => {
          if (handle === this.sfutest) {
            this.publishStatus = false;
          }
          Janus.error("WebRTC error:", error);
        },
      });
    },
    newRemoteFeed(list, attemptId, session) {
      console.log(list);
      for (let f in list) {
        console.log(list[f]);
        if (list[f]["dummy"]) continue;
        if (list[f]["display"][0] !== "p") {
          continue;
        }
        console.log("订阅远程");
        let id = list[f]["id"];
        const subscriberKey = String(id);
        if (this.houseOwner && this.houseOwner != id) {
          const previousHouseOwner = this.houseOwner;
          this.removeMonitorSubscriber(previousHouseOwner);
          this.feedStreams = this.feedStreams.filter(
            (item) => item[0]?.id != previousHouseOwner
          );
        }
        this.houseOwner = id;
        let display = list[f]["display"];
        let streams = list[f]["streams"];
        if (!Array.isArray(streams) || streams.length === 0) {
          continue;
        }
        streams[0].useVideo = false;
        streams[0].useAudio = false;
        for (let i in streams) {
          let stream = streams[i];
          stream["id"] = id;
          stream["display"] = display;
        }
        let findIndex = -1;
        for (let i = 0; i < this.feedStreams.length; i++) {
          if (this.feedStreams[i][0].id == id) {
            findIndex = i;
          }
        }
        //避免同一个人的视频被多次添加！
        //未加载成功时，显示视频的loading
        streams[0].showLoading = true;
        if (findIndex != -1) {
          this.feedStreams[findIndex] = streams;
        } else {
          this.feedStreams.push(streams);
        }
        console.log(this.feedStreams);

        if (this.subscriberHandles.has(subscriberKey)) {
          continue;
        }
        const pendingSubscriber = {};
        this.subscriberHandles.set(subscriberKey, pendingSubscriber);
        //加入到本地
        let remoteFeed = null;
        session.attach({
          plugin: "janus.plugin.videoroom",
          opaqueId: this.opaqueId,
          success: (pluginHandle) => {
            if (
              !this.isCurrentMonitorAttempt(attemptId, session) ||
              this.subscriberHandles.get(subscriberKey) !== pendingSubscriber
            ) {
              pluginHandle.detach?.({ noRequest: true });
              return;
            }
            remoteFeed = pluginHandle;
            this.subscriberHandles.set(subscriberKey, remoteFeed);
            remoteFeed.remoteTracks = {};
            remoteFeed.remoteVideos = 0;
            remoteFeed.simulcastStarted = false;

            //
            let subscription = [];
            for (let i in streams) {
              let stream = streams[i];
              subscription.push({
                feed: stream.id, // This is mandatory
                mid: stream.mid, // This is optional (all streams, if missing)
              });
              // FIXME Right now, this is always the same feed: in the future, it won't
              remoteFeed.rfid = stream.id;
              remoteFeed.rfdisplay = this.escapeXmlTags(stream.display);

              //去掉loading的显示
              this.feedStreams.forEach((item) => {
                if (item[0].id == stream.id) {
                  item[0].showLoading = false;
                }
              });
            }

            var subscribe = {
              request: "join",
              room: this.myroom,
              ptype: "subscriber",
              streams: subscription,
              //use_msid 不知道具体功能
              use_msid: false,
              private_id: this.mypvtid,
            };
            remoteFeed.send({ message: subscribe });
          },
          error: (error) => {
            if (
              !this.isCurrentMonitorAttempt(attemptId, session) ||
              this.subscriberHandles.get(subscriberKey) !== pendingSubscriber
            ) {
              return;
            }
            this.subscriberHandles.delete(subscriberKey);
            this.handleMonitorSessionFailure(
              attemptId,
              session,
              "Error attaching monitor subscriber: " + error
            );
          },
          iceState: (state) => {
            if (
              !this.isCurrentMonitorSubscriber(
                subscriberKey,
                remoteFeed,
                attemptId,
                session
              )
            ) {
              return;
            }
            Janus.log(
              "ICE state (feed #" + remoteFeed.rfindex + ") changed to " + state
            );
          },
          webrtcState: (on) => {
            if (
              !this.isCurrentMonitorSubscriber(
                subscriberKey,
                remoteFeed,
                attemptId,
                session
              )
            ) {
              return;
            }
            //远程流的状态!
            remoteFeed.send({
              message: { request: "configure", bitrate: 256000 },
            });
          },
          slowLink: (uplink, lost, mid) => {
            console.log("slow!");
          },
          onmessage: (msg, jsep) => {
            if (
              !this.isCurrentMonitorSubscriber(
                subscriberKey,
                remoteFeed,
                attemptId,
                session
              )
            ) {
              return;
            }
            let event = msg["videoroom"];
            if (msg["error"]) {
              console.log(msg["error"]);
            } else if (event) {
              if (event === "attached") {
              } else if (event === "event") {
                let substream = msg["substream"];
                let temporal = msg["temporal"];
                if (
                  (substream !== null && substream !== undefined) ||
                  (temporal !== null && temporal !== undefined)
                ) {
                  if (!remoteFeed.simulcastStarted) {
                    remoteFeed.simulcastStarted = true;
                  }
                }
              }
            }

            if (jsep) {
              let stereo = jsep.sdp.indexOf("stereo=1") !== -1;
              // Answer and attach
              remoteFeed.createAnswer({
                jsep: jsep,
                tracks: [{ type: "data" }],
                customizeSdp: (jsep) => {
                  if (stereo && jsep.sdp.indexOf("stereo=1") == -1) {
                    // Make sure that our offer contains stereo too
                    jsep.sdp = jsep.sdp.replace(
                      "useinbandfec=1",
                      "useinbandfec=1;stereo=1"
                    );
                  }
                },
                success: (jsep) => {
                  if (
                    !this.isCurrentMonitorSubscriber(
                      subscriberKey,
                      remoteFeed,
                      attemptId,
                      session
                    )
                  ) {
                    return;
                  }
                  let body = { request: "start", room: this.myroom };
                  remoteFeed.send({ message: body, jsep: jsep });
                },
                error: (error) => {
                  if (
                    !this.isCurrentMonitorSubscriber(
                      subscriberKey,
                      remoteFeed,
                      attemptId,
                      session
                    )
                  ) {
                    return;
                  }
                  this.handleMonitorSessionFailure(attemptId, session, error);
                },
              });
            }
          },
          //不会调用local，无需处理
          onlocaltrack: (track, on) => {
            if (
              !this.isCurrentMonitorSubscriber(
                subscriberKey,
                remoteFeed,
                attemptId,
                session
              )
            ) {
              if (on) {
                track.stop?.();
              }
              return;
            }
            console.log("onlocaltrack");
          },
          onremotetrack: (track, mid, on) => {
            if (
              !this.isCurrentMonitorSubscriber(
                subscriberKey,
                remoteFeed,
                attemptId,
                session
              )
            ) {
              return;
            }
            console.log("onremotetrack");
            if (!on) {
              if (track.kind === "audio") {
                delete remoteFeed.remoteTracks[mid];
                if (
                  JQuery("#remoteMonitorAudio").get(0) &&
                  JQuery("#remoteMonitorAudio").get(0) !== null
                ) {
                  Janus.attachMediaStream(JQuery("#remoteMonitorAudio").get(0), null);
                }
              } else {
                delete remoteFeed.remoteTracks[mid];
                if (
                  JQuery("#remoteMonitorVideo").get(0) &&
                  JQuery("#remoteMonitorVideo").get(0) !== null
                ) {
                  Janus.attachMediaStream(JQuery("#remoteMonitorVideo").get(0), null);
                }
              }
              return;
            }
            console.log(remoteFeed.rfid);
            console.log(this.feedStreams);
            if (remoteFeed.spinner) {
              remoteFeed.spinner.stop();
              remoteFeed.spinner = null;
            }
            if (track.kind === "audio") {
              let stream = new MediaStream([track]);
              remoteFeed.remoteTracks[mid] = stream;
              const audioElement = document.getElementById("remoteMonitorAudio");
              if (audioElement) {
                Janus.attachMediaStream(audioElement, stream);
                audioElement.volume = 1;
                audioElement.play().catch((error) => {
                  console.log("remote monitor audio play failed:", error);
                });
              }
            } else if (track.kind === "video") {
              let stream = new MediaStream([track]);
              remoteFeed.remoteTracks[mid] = stream;
              const videoElement = document.getElementById("remoteMonitorVideo");
              if (videoElement) {
                Janus.attachMediaStream(videoElement, stream);
                this.markMonitorVideoReady(videoElement);
              }
            }
          },
          ondata: (data) => {
            if (
              !this.isCurrentMonitorSubscriber(
                subscriberKey,
                remoteFeed,
                attemptId,
                session
              )
            ) {
              return;
            }
            console.log(data);
          },
          oncleanup: () => {
            if (
              !this.isCurrentMonitorSubscriber(
                subscriberKey,
                remoteFeed,
                attemptId,
                session
              )
            ) {
              return;
            }
            if (remoteFeed.spinner) remoteFeed.spinner.stop();
            remoteFeed.spinner = null;
            //delete
            //这里通过v-if来处理？
            remoteFeed.remoteTracks = {};
            remoteFeed.remoteVideos = 0;
          },
          ondetached: () => {
            if (this.subscriberHandles.get(subscriberKey) === remoteFeed) {
              this.subscriberHandles.delete(subscriberKey);
              remoteFeed.remoteTracks = {};
              remoteFeed.remoteVideos = 0;
            }
          },
        });
      }
    },
    doHangup({ navigateBack = true } = {}) {
      const leavePromise = this.ensureMonitorLeavePromise();
      if (this.monitorLeaving) {
        if (!navigateBack) {
          this.monitorNavigateBackOnLeave = false;
        }
        return leavePromise;
      }
      this.monitorLeaving = true;
      this.monitorNavigateBackOnLeave = navigateBack;
      this.hanguproom = this.myroom;
      this.myroom = null;
      this.$emit("monitor", { toPage: "app", method: "setMyRoom", myroom: "" });

      const handle = this.sfutest;
      if (!handle || this.janus?.isConnected?.() !== true) {
        this.finishMonitorLeave();
        return leavePromise;
      }

      try {
        handle.send({ message: { request: "leave" } });
        handle.hangup();
      } catch (error) {
        Janus.error("Failed to leave monitor room:", error);
        this.finishMonitorLeave();
        return leavePromise;
      }
      this.clearTimer("monitorLeaveTimer");
      this.monitorLeaveTimer = setTimeout(() => {
        this.monitorLeaveTimer = null;
        if (this.monitorLeaving) {
          this.finishMonitorLeave();
        }
      }, 2000);

      if (this.userInfo?.type === "5") {
        this.publishStatus = false;
        if (this.watching_list.length == 0) {
          this.destroyRoom(this.hanguproom, handle);
        }
        Janus.stopAllTracks(this.localStream);
      }
      return leavePromise;
    },
    finishMonitorLeave() {
      if (!this.monitorLeaving) {
        return;
      }
      const roomId = this.hanguproom;
      const shouldSaveLog =
        this.userInfo?.type === "4" &&
        this.monitorState === "joined" &&
        !!roomId;
      const shouldNavigateBack =
        this.monitorNavigateBackOnLeave &&
        this.userInfo?.type === "4" &&
        this.$route.path === "/monitorRoom";
      this.hanguproom = null;
      this.clearTimer("successTimer");
      Toast.clear();
      this.resetMonitorSession();
      this.monitorNavigateBackOnLeave = true;

      if (shouldSaveLog) {
        SaveMonitorLog({
          patient_id: this.patient_id,
          room_id: roomId,
          type: "leave",
        }).catch((error) => Janus.error(error));
      }
      if (shouldNavigateBack && this.$route.path === "/monitorRoom") {
        this.$router.go(-1);
      }
      this.resolveMonitorLeave();
      this.resumeAiAnalysis();
    },
    unpublishFeed() {
      // 停止发布
      var unpublish = { request: "unpublish" };
      this.sfutest?.send({ message: unpublish });
    },
    destroyRoom(myroom, handle = this.sfutest) {
      if (!handle || !myroom) {
        return;
      }
      var destroy = {
        request: "destroy",
        room: myroom,
        permanent: false,
      };
      handle.send({ message: destroy });
    },
    createRoom(handle = this.sfutest) {
      if (!handle || !this.myroom) {
        return;
      }
      var created = {
        request: "create",
        room: this.myroom,
        permanent: false,
        is_private: false,
        publishers: this.publishers_num,
        notify_joining: true,
      };
      handle.send({ message: created });
    },
    registerRoomUser(handle = this.sfutest) {
      if (!handle || !this.myroom) {
        return;
      }
      let name = Math.round(Math.random() * (9999 - 1000) + 1000) + "";
      if (this.userInfo.type == "5") {
        name = "p" + name;
      }else if (this.ai_mode) {
        name = "ai"+name;
      }
      // 患者以p开头
      var register = {
        request: "join",
        room: this.myroom,
        ptype: "publisher",
        display: name,
      };
      handle.send({ message: register });
    },
    escapeXmlTags(value) {
      if (value) {
        var escapedValue = value.replace(new RegExp("<", "g"), "&lt");
        escapedValue = escapedValue.replace(new RegExp(">", "g"), "&gt");
        return escapedValue;
      }
    },

    holdingMonitorWithTime(time){
      if (
        !this.aiAnalysisStarted ||
        this.aiAnalysisPaused ||
        this.isExclusiveMediaRoute()
      ) {
        return;
      }
      let userInfo = JSON.parse(localStorage.getItem(process.env.VUE_APP_USER_KEY));
      if (!userInfo?.login_account_id) {
        return;
      }
      this.clearTimer("aiHoldingTimer");
      if(this.ai_mode){
        this.holdingTime = 2000;
        // 高速模式
        lockPatientMonitor({patient_id: userInfo.login_account_id,});
      }else{
        this.holdingTime = 5000;
        // 低速模式
        releasePatientMonitor({patient_id: userInfo.login_account_id,});
      }
      this.aiHoldingTimer = setTimeout(() => {
        this.aiHoldingTimer = null;
        this.holdingMonitor();
      }, time);
    },
    async holdingMonitor() {
      if (
        !this.aiAnalysisStarted ||
        this.aiAnalysisPaused ||
        this.isExclusiveMediaRoute()
      ) {
        return;
      }
      let userInfo = JSON.parse(localStorage.getItem(process.env.VUE_APP_USER_KEY));
      if(userInfo.monitor_open_flg !== "1" || userInfo.ai_analysis_flg !== "1"){
        // 未开启监护模式 和 AI分析 1m后重试
        this.holdingMonitorWithTime(60000);
        if(this.ai_stream){
          console.log("摄像头需要关闭");
          this.ai_stream.getTracks().forEach(track => track.stop());
          this.ai_stream = null;
        }
        return;
      }
      if(this.ai_stream){
        console.log("摄像头开启中");
        // 判断摄像头已经开启了多久
        const currentTime = new Date();
        const timeDifference = Math.floor((currentTime - this.ai_camera_time) / 1000);
        // 5分钟 5*60
        if(timeDifference >= 300){
          console.log("摄像头需要重启");
          this.ai_stream.getTracks().forEach(track => track.stop());
          this.ai_stream = null;
          // 休息3秒钟
          this.holdingMonitorWithTime(3000);
          return;
        }
        let context = this.$refs.canvas.getContext('2d');
        context.drawImage(this.$refs.video, 0, 0, this.videoWidth, this.videoHeight);
        const imgData = this.$refs.canvas.toDataURL('image/png');
        const blob = this.dataURLtoBlob(imgData);
        const fileName = `${userInfo.login_account_id}-${Date.now()}.png`;
        let formData = new FormData();
        formData.append('image', blob, fileName);
        let res = await UploadImage(formData);
        if (res && res.data.code >= 0) {
          // 上传成功等待下一次
          this.holdingMonitorWithTime(this.holdingTime);
        }else{
          // 上传失败 30s后重试
          this.holdingMonitorWithTime(30000);
        }
      }else{
        if(this.aiMediaRequestPending){
          return;
        }
        this.aiMediaRequestPending = true;
        const requestId = ++this.aiMediaRequestId;
        console.log("摄像头启动");
        // 获取摄像头资源并设置
        const constraints = {
          audio: false,
          video: { width: this.videoWidth,height: this.videoHeight,transform: "scaleX(-1)"},
        };
        navigator.mediaDevices.getUserMedia(constraints).then((stream) => {
          if (
            requestId !== this.aiMediaRequestId ||
            this.aiAnalysisPaused ||
            this.isExclusiveMediaRoute()
          ) {
            if (requestId === this.aiMediaRequestId) {
              this.aiMediaRequestPending = false;
            }
            stream.getTracks().forEach((track) => track.stop());
            return;
          }
          this.aiMediaRequestPending = false;
          this.ai_stream = stream;
          this.ai_camera_time = new Date();
          if ("srcObject" in this.$refs.video) {
            this.$refs.video.srcObject = stream;
          } else {
            // 避免在新的浏览器中使用它，因为它正在被弃用。
            this.$refs.video.src = window.URL.createObjectURL(stream);
          }
          this.$refs.video.onloadedmetadata = () => {
            this.$refs.canvas.width = this.videoWidth;
            this.$refs.canvas.height = this.videoHeight;
            this.$refs.video.play();
          };
          // 成功设置资源 1秒后开始截图
          this.holdingMonitorWithTime(1000);
        }).catch((error) => {
          if (requestId !== this.aiMediaRequestId) {
            return;
          }
          this.aiMediaRequestPending = false;
          console.log(error);
          Toast("カメラ権限が異常です。");
          // 失败 30s后重试
          this.holdingMonitorWithTime(30000);
        });
      }
    },
    dataURLtoBlob(dataurl) {
      const arr = dataurl.split(',');
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      const u8arr = new Uint8Array(bstr.length);
      for(let i = 0; i < bstr.length; i++) {
        u8arr[i] = bstr.charCodeAt(i);
      }
      return new Blob([u8arr], { type: mime });
    },
  },
  watch: {
    "$route.path": {
      immediate: true,
      handler(path) {
        if (this.isExclusiveMediaRoute(path)) {
          this.pauseAiAnalysis();
        } else {
          this.resumeAiAnalysis();
        }
      },
    },
  },
};
</script>

<style scoped></style>
